import type { GatsbyBrowser } from "gatsby"

import { createGlobalStyle } from "styled-components"

import style from "./style"

const GlobalStyles = createGlobalStyle`
  ${style}
`

const Page: GatsbyBrowser["wrapPageElement"] = ({ element }) => {
  // This wrapper is mounted once but re-rendered on page change
  // https://www.gatsbyjs.org/docs/browser-apis/#wrapPageElement
  return (
    <>
      <GlobalStyles />
      {element}
    </>
  )
}

export default Page
